import { gsap, ScrollTrigger, SplitText } from 'gsap/all'
gsap.registerPlugin(SplitText, ScrollTrigger)

export function splitTitle(
  title: HTMLElement,
  scrolltriggerAttributes?: { trigger?: HTMLElement; start?: string; end?: string; markers?: boolean }
) {
  const { trigger, start, end, markers } = scrolltriggerAttributes || {}
  const innerChars = new SplitText(title, {
    type: 'chars, words',
    linesClass: 'lineChild'
  })

  const outerTitle = new SplitText(title, {
    type: 'lines',
    linesClass: 'lineParent'
  })

  gsap.set(outerTitle.lines, { perspective: 2000 })
  gsap.set(innerChars.chars, {
    'will-change': 'opacity, transform',
    'opacity': 0,
    'rotationX': -90,
    'yPercent': 0
  })

  runTitleAnim()

  function runTitleAnim() {
    // get parent section
    const parentSection = title.closest('section')

    const titleAnim = gsap.timeline({
      scrollTrigger: {
        trigger: trigger ? trigger : parentSection,
        start: start || 'top center',
        end: end || 'center center',
        // scrub: 0.9,
        once: true,
        invalidateOnRefresh: true,
        markers: markers || false
      }
    })

    titleAnim.to(innerChars.chars, {
      // ease: 'power1.inOut',
      ease: 'expo.out',
      opacity: 1,
      autoAlpha: 1,
      duration: 1.5,
      rotationX: 0,
      yPercent: 0,
      stagger: {
        each: 0.03,
        from: 0
      }
    })
  }
}
